import { Notification } from 'models';
import { uniqueArray } from 'utils';
import { NOTIFICATION_TYPE } from 'constant';

export const resolveUpdateAction = ({ state = {}, type = '', successMessage }) => {
  const { pendingActions = [] } = state;
  const actionIndex = pendingActions.indexOf(type);

  if (actionIndex !== -1) {
    pendingActions.splice(actionIndex, 1);
  }

  return {
    ...state,
    notifications: [
      Notification({
        action: type,
        message: successMessage || 'Item has been updated',
        type: NOTIFICATION_TYPE.SUCCESS,
      }),
    ],
    pendingActions: uniqueArray(pendingActions),
  };
};

export const resolveDeleteAction = ({ state = {}, type = '', successMessage }) => {
  const { pendingActions = [] } = state;
  const actionIndex = pendingActions.indexOf(type);

  if (actionIndex !== -1) {
    pendingActions.splice(actionIndex, 1);
  }

  return {
    ...state,
    notifications: [
      Notification({
        action: type,
        message: successMessage || 'Item will be deleted',
        type: NOTIFICATION_TYPE.SUCCESS,
      }),
    ],
    pendingActions: uniqueArray(pendingActions),
  };
};

export const resolveCreateAction = ({ state = {}, type = '', successMessage }) => {
  const { pendingActions = [] } = state;
  const actionIndex = pendingActions.indexOf(type);

  if (actionIndex !== -1) {
    pendingActions.splice(actionIndex, 1);
  }

  return {
    ...state,
    notifications: [
      Notification({
        action: type,
        message: successMessage || 'The item is provisioning and will be created soon',
        type: NOTIFICATION_TYPE.SUCCESS,
      }),
    ],
    pendingActions: uniqueArray(pendingActions),
  };
};

export const resolveGetAction = ({ state = {}, type = '', payload = {} }) => {
  const { pendingActions = [] } = state;
  const actionIndex = pendingActions.indexOf(type);

  if (actionIndex !== -1) {
    pendingActions.splice(actionIndex, 1);
  }

  return {
    ...state,
    pendingActions,
    ...payload,
  };
};

export const identifyActionType = (action = '') => {
  const [, isAction = null] = action.match(/::(.+)$/) || [];
  return isAction;
};
